// extracted by mini-css-extract-plugin
module.exports = {"slogan":"Slogan_slogan__3aRBP"};